var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"pointer",attrs:{"src":"/assets/img/icons/trash.svg","alt":"Delete Product"},on:{"click":_vm.openDeleteItem}}),_c('DeleteItemModal',{attrs:{"id":`${_vm.item.reference}`,"closeModal":_vm.closeModal,"itemsRef":_vm.itemsRef,"item":_vm.item}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }